import * as yup from 'yup';

const resolveNoteSchema = yup.object().shape({
  resolutionNotes: yup.string().trim().required('Resolution notes are required'),
});

export default resolveNoteSchema;